import { useMemo } from 'react';

import withComponentEnhancer from './withComponentEnhancer';

import ComponentRendererWithoutAuth from '../components/ComponentRendererWithoutAuth';
import { TComponentRendererEnhancerProps } from '../types';
import ComponentRenderer from '../components/ComponentRenderer';

// Added withAuthCall prop for potential future replacement of withComponentRenderer.
// No authentication call is needed when rendering component in app rendered using shell.
const withComponentRendererEnhancer = <P extends {}>({
  streamName,
  appName,
  graphqlEndpoint,
  graphqlEndpoints,
  collectorUrl,
  enableRedux,
  loader,
  baseDomain,
  enableSubscription,
  withAuthCall = false,
  environmentOptions,
}: TComponentRendererEnhancerProps) => {
  if (!(streamName && appName))
    throw new Error('Missing parameters: streamName & appName are required');

  graphqlEndpoint = graphqlEndpoint || graphqlEndpoints?.[0];

  let enhancer = withComponentEnhancer<P>({
    streamName,
    appName,
    graphqlEndpoint,
    collectorUrl,
    enableRedux,
    enableSubscription,
    environmentOptions,
  });

  return (Component: React.ComponentType<P>) => (props: P) => {
    const ComponentToRender = useMemo(() => enhancer(Component), []);
    const Renderer = withAuthCall ? ComponentRenderer : ComponentRendererWithoutAuth;

    return (
      <Renderer loader={loader} baseDomain={baseDomain} appName={appName}>
        <ComponentToRender {...props} />
      </Renderer>
    );
  };
};

export default withComponentRendererEnhancer;
